import { FloatingInspectorButtonIcon } from '../FloatingInspectorButtons'
import { requestLimitedTimeOfferOnEditorExit } from '@/components/ShowModal/LimitedTimeOfferLifecycle'
import WrapPopover from '../SharedComponents/Popover/WrapPopover'
import LogoIcon from '@assets/images/logo_only.svg'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useEditorContext } from '@/scenes/engine'
import { selectUser } from '@/store/slices/user/selectors'
import { useSelector } from 'react-redux'
import { SAVE_PROJECT_STATE, ShowModalType } from '@/scenes/engine/common/constants'
import useAppContext from '@/hooks/useAppContext'
import useModal from '@/hooks/useModal'
import { useAppDispatch } from '@/store/store'
import { setUploads } from '@/store/slices/uploads/actions'
import { customAmplitude } from '@/utils/customAmplitude'
import { SyncManager } from '@/firebase/SyncManager'
import { useRouteMatch } from 'react-router'
import { VerticalListButton } from '../SharedComponents/Popover/VerticalListButton'
import { HorizontalSeparator } from '../SharedComponents/Popover/HorizontalSeparator'
import { NavbarButtonBaseProps } from '../../Navbar/navbarConfig'

function LogoIconBtnWithPopover({ disabled }: NavbarButtonBaseProps) {
  return (
    <FloatingInspectorButtonIcon
      onClick={() => {}}
      disabled={disabled}
      disabledStyle={'transparentBackground'}
      style={{ height: '40px', padding: '6px', gap: '8px', borderRadius: '12px' }}
      icon={
        <img
          src={LogoIcon}
          style={{
            height: '28px',
            width: '28px',
            opacity: disabled ? 0.5 : 1,
          }}
        />
      }
      showArrow="down"
      popoverContent={(buttonRef, closePopover) => (
        <WrapPopover padding={16} width={224} gap={0} placement="bottomLeft" closeOnSelection closePopover={closePopover} buttonRef={buttonRef}>
          <LogoDropdown />
        </WrapPopover>
      )}
    />
  )
}

export default LogoIconBtnWithPopover

function LogoDropdown() {
  const [t] = useTranslation()
  const history = useHistory()
  const { setSaveProjectState } = useAppContext()
  const { setShowModalType } = useModal()

  const editor = useEditorContext().editor
  const dispatch = useAppDispatch()
  const user = useSelector(selectUser)
  const match = useRouteMatch<{ id: string }>('/design/:id/edit')
  const id = match?.params?.id ?? null
  const isSavedProject = Boolean(id)
  
  const showSaveProjectModal = async (): Promise<boolean> => {
    if (!editor.handlers.transactionHandler.isFlushed) {
      if (!user) {
        setShowModalType(ShowModalType.DISCARD_PROJECT)
        return false
      }
    }
    dispatch(setUploads([]))
    return true
  }
  const onHomeClick = async () => {
    const shouldProceed = await showSaveProjectModal()
    if (!shouldProceed) return
    requestLimitedTimeOfferOnEditorExit()
    history.push('/create')
    customAmplitude('Open', { Source: 'Editor' })
    // @ts-ignore
    window.dataLayer.push({ event: 'header_home_clicked' })
  }

  const onProjectsClick = async () => {
    const shouldProceed = await showSaveProjectModal()
    if (!shouldProceed) return
    requestLimitedTimeOfferOnEditorExit()
    history.push('/create/projects')
  }

  const onDeleteClick = () => {
    SyncManager.shared.idDeleteProject = [id]
    setShowModalType(ShowModalType.DELETE_PROJECT)
  }
  return (
    <>
      <VerticalListButton text={t('Home')}        variant="menu" onClick={onHomeClick} />
      <VerticalListButton text={t('Projects')}     variant="menu" onClick={onProjectsClick} />
      <HorizontalSeparator />
      <VerticalListButton text={t('New project')}  variant="menu" onClick={() => { window.open('/', '_blank'); customAmplitude('Create', { Source: 'New project' }) }} />
      <VerticalListButton text={t('Delete Project')} variant="menu-danger" disabled={!isSavedProject} onClick={onDeleteClick} />
    </>
  )
}
